import {
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
} from '@chakra-ui/react';
import React from 'react';

interface IProps {
  isOpen: boolean;
  onClose: () => void;
  onUnpublishClick: () => void;
  title: string;
}

export const UnpublishModal: React.FC<IProps> = ({
  isOpen,
  onClose,
  onUnpublishClick,
  title,
}) => {
  return (
    <>
      <Modal isOpen={isOpen} onClose={onClose} isCentered>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Recall Homework </ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            Are you sure you want to recall this homework - {title}？
          </ModalBody>

          <ModalFooter>
            <Button colorScheme="blue" mr={3} onClick={onClose}>
              No
            </Button>
            <Button variant="ghost" onClick={onUnpublishClick}>
              Yes
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
};
